import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class UserLog extends Http {
  [x: string]: any
  public async getUserLog(data: NLoginApi.UserLogRequestData) {
    return await super.request<NLoginApi.UserLogResponse>({
      url: '/log/userlog',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getUserName(data: NLoginApi.UserNameRequestData) {
    return await super.request<NLoginApi.UserNameResponse>({
      url: '/log/getAllUsername',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default UserLog
